export const initTSMButton = () => {
  const tsmButton = document.getElementById('tsm-button');
  if (!tsmButton) return;
  const tsm = document.getElementById('tsm');
  const tsmTitle = document.querySelector('.tsm__title');

  tsmButton.addEventListener('click', () => {
    tsmButton.setAttribute(
      'aria-expanded',
      tsmButton.getAttribute('aria-expanded') === 'false' ? 'true' : 'false',
    );
    tsm.classList.toggle('tsm--expanded');
  });

  tsmTitle.addEventListener('click', () => {
    tsmButton.setAttribute(
      'aria-expanded',
      tsmButton.getAttribute('aria-expanded') === 'false' ? 'true' : 'false',
    );
    tsm.classList.toggle('tsm--expanded');
  });
};

export default 'initTSMButton';
